export const environment = {
    production: true,
    backendConfiguratorUrl: 'https://configurator.regenero.hu',
    apiUrl: 'https://regenero.hu/',
    downloadUrl: 'https://file.regenero.hu/file/downloadFile',
    regeneroBaseUrl: 'https://backend.regenero.hu',
    googleTagContainerId: 'GTM-KGXVN6G2',
    googleTagId: 'G-FSXD4GP65B'

};
